export default __webpack_public_path__ + "static/media/bullet.64745812.svg";